import { searchString } from '@/services/router/search-scalars';

/** A create link from a form's page names the form, so the new automation starts triggered by it. */
export type CreateAutomationSearch = {
  triggerFormId?: string;
  formType?: string;
};

/** The two params as `validateSearch` receives them, unparsed. */
type UnvalidatedCreateAutomationSearch = {
  triggerFormId?: unknown;
  formType?: unknown;
};

export function validateCreateAutomationSearch(search: UnvalidatedCreateAutomationSearch): CreateAutomationSearch {
  return { triggerFormId: searchString(search.triggerFormId), formType: searchString(search.formType) };
}
